export default __webpack_public_path__ + "static/media/Elec4.0c209f88.png";